import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi, OpalApiResponseDocument } from '../../schema'

type Operation = 'UpdateContentV3'
type UpdateContentV3 = OpalApi<Operation, 201>
type ResponseData = OpalApiResponseDocument<Operation, 201>

export const updateContent: UpdateContentV3 = async ({
  params,
  requestBody,
}: Parameters<UpdateContentV3>[0] = {}) => {
  const contentId = params?.path?.content_id
  if (!contentId) {
    throw new Error('contentId is a required path parameter')
  }

  const url = new URL(`/content/v3/${contentId}`, window.location.origin)

  const query = params?.query
  url.search = queryString({
    'expose[meta][access]': String(!!query?.expose?.meta?.access),
  })

  return HttpClient()
    .patch<ResponseData>(url.toString(), requestBody)
    .then((res) => res.data)
}
